import { isEmpty } from "lodash";
import React from "react";
import JobTypes from "../../assets/images/jobTypes.png";
import "../../css/profileCompletionJourney.css";

type PropTypes = {
  jobSkills: Array<string> | undefined;
  jobProfessions: Array<string> | undefined;
  jobCategory: Array<string> | undefined;
};

function JobRelatedInfoMap(props: PropTypes) {
  const { jobSkills, jobProfessions, jobCategory } = props;

  return (
    <div style={{ paddingLeft: "20px" }}>
      {!isEmpty(jobCategory) && (
        <div className="profile_completion_item_section">
          <img
            src={JobTypes}
            style={{ height: "30px", width: "30px", marginRight: "28px" }}
          />
          <div className="flex_column_align_center" style={{width:'100%',alignItems:'center'}}>
            <text
              className="profile_completion_item_heading profile_completion_map_heading_style"
              >
              My Job Catergory is{" "}
            </text>
            {jobCategory &&
              jobCategory.map((item) => (
                <text
                  className="profile_completion_item_text"
                  style={{ textAlign: "center" }}
                >
                  {item}
                </text>
              ))}
          </div>
        </div>
      )}

      {!isEmpty(jobProfessions) && (
        <div className="profile_completion_item_section">
          <img
            src={JobTypes}
            style={{ height: "30px", width: "30px", marginRight: "28px" }}
          />
          <div className="flex_column_align_center" style={{width:'100%',alignItems:'center'}}>
            <text
              className="profile_completion_item_heading profile_completion_map_heading_style"
              >
              {jobProfessions!?.length<=0? "My Profession is ":"My Professions are "}

            </text>
            {jobProfessions &&
              jobProfessions.map((item) => (
                <text
                  className="profile_completion_item_text"
                  style={{ textAlign: "center" }}
                >
                  {item}
                </text>
              ))}
          </div>
        </div>
      )}

      {!isEmpty(jobSkills) && (
        <div className="profile_completion_item_section">
          <img
            src={JobTypes}
            style={{ height: "30px", width: "30px", marginRight: "28px" }}
          />
          <div className="flex_column_align_center" style={{width:'100%',alignItems:'center'}}>
            <text
              className="profile_completion_item_heading profile_completion_map_heading_style"
            >
             {jobSkills!?.length<=0? "My skill is ":"My skills are "}
            </text>

            {jobSkills &&
              jobSkills.map((item) => (
                <text
                  className="profile_completion_item_text"
                  style={{ textAlign: "center" }}
                >
                  {item}
                </text>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default JobRelatedInfoMap;
